export default __webpack_public_path__ + "5987ad850aa07b82211fed7e6af5be15.svg";